
export const TwittterCardSize = {
  SMALL: 'summary',
  LARGE: 'summary_large_image'
}